/**
 * SiteTableItem 모델 - 테이블 표시용 객체
 */

import { ISitePublic } from './SitePublic';

/**
 * 테이블 표시용 사이트 인터페이스
 */
export interface ISiteTableItem extends ISitePublic {
  actions?: any; // 테이블 액션 컬럼용
}

/**
 * 기본값 객체들
 */
export const SiteTableItemDefaults = {
  tableItem: {
    seq: null,
    name: '',
    address: '',
    establishedDate: null,
    pvModuleMaker: '',
    powerCapacity: 0,
    pvModuleCount: 0,
    pvModuleOutput: 0,
    description: '',
    rotation: null,
    location: {
      coordinates: [0, 0],
      crs: { properties: { name: 'EPSG:4326' }, type: 'name' },
      type: 'Point'
    },
    ownerCompany: { seq: null, companyName: '' },
    operationCompany: { seq: null, companyName: '' },
    managers: [],
    status: 'active',
    type: 'solar',
    project: { seq: null, name: '' },
    panelProductSeq: null,
    actions: null
  } as ISiteTableItem
};

/**
 * 팩토리 함수들
 */
export const SiteTableItemFactory = {
  /**
   * 빈 테이블 아이템 생성
   */
  createEmpty(): ISiteTableItem {
    return { ...SiteTableItemDefaults.tableItem };
  },
  
  /**
   * SitePublic에서 테이블 아이템 생성
   */
  fromSitePublic(sitePublic: ISitePublic): ISiteTableItem {
    if (!sitePublic) return this.createEmpty();
    return {
      ...sitePublic,
      actions: null
    };
  },
  
  /**
   * 배열 형태의 SitePublic에서 테이블 아이템 배열 생성
   */
  fromSitePublicArray(sitePublicArray: ISitePublic[]): ISiteTableItem[] {
    if (!Array.isArray(sitePublicArray)) return [];
    return sitePublicArray.map(item => this.fromSitePublic(item));
  }
};

/**
 * 기본 export
 */
export default {
  SiteTableItemDefaults,
  SiteTableItemFactory
};
